// extracted by mini-css-extract-plugin
export default {"linksSection":"tH-z"};